module.exports = "/_next/static/images/wallet-empty-neue@2x-eba6e86bc702777ec7011c37a4dad304.png";